export default __webpack_public_path__ + "static/media/icon-star.263aa37c.svg";